import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '@environments/environment';
import { DataService } from '@app/_services/data.service';
import { ITuple } from '@app/_models/tuple';
import { Asset } from '@app/_models/_DTOs/asset';
import { User } from '@app/_models/_DTOs/user';

@Injectable({ providedIn: 'root' })
export class UserService extends DataService<User> {
    constructor(http: HttpClient) {
        super(http, "api/Accounts")
    }

    deleteUser(userIdentityId: string) {
        var url = `${environment.apiUrl}/${this.endpoint}/${userIdentityId}`;
        return this.http.delete(url);
    }
}